import React from "react"

import {
	Page,
	HeadTags,
} from "components/webinar/components"

import PageNotFound from "components/page-not-found"
import {
	WEBINAR_PAGES,
} from "./constants"

function matchPage(url, pages) {
	const filteredMatch = pages.filter(p => p.url === url)
	if(!filteredMatch.length) {
		return false
	}

	return filteredMatch[0]
}

const WebinarComponent = ({match, page}) => {

	const pageMatch = matchPage(match.params.page, WEBINAR_PAGES)
	return (
		<div className="app-page">

			<HeadTags data={pageMatch}/>

			{pageMatch && (
				<Page
					data={pageMatch}
					fbPixelId={process.env.REACT_APP_FB_PIXEL_ID}
					gtagId={process.env.REACT_APP_GTAG_ID}
					gtagCampaignId={process.env.REACT_APP_GTAG_CAMPAIGN_ID}
					videoSrc={pageMatch.src}
					verbose={process.env.REACT_APP_VERBOSE}/>
			)}

			{!pageMatch && (
				<PageNotFound />
			)}
			
		</div>
	)
}

export default WebinarComponent;